import { combineReducers } from 'redux';
import appDux from './app';
import jobDesignsDux from './jobDesigns';
import jobShareDux from './jobShare';
import macheteDux from './machete';
import measureModeDux from './measureMode';
import notificationDux from './notification';
import splitDux from './split';
import uiDux from './ui';
import undoDux from './undo';
import userDux from './user';

export default combineReducers({
  app: appDux.reducer,
  jobDesigns: jobDesignsDux.reducer,
  jobShare: jobShareDux.reducer,
  machete: macheteDux.reducer,
  measure: measureModeDux.reducer,
  notification: notificationDux.reducer,
  split: splitDux.reducer,
  ui: uiDux.reducer,
  undo: undoDux.reducer,
  user: userDux.reducer,
});
